import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {UpscaleImagesParams} from '@wix/document-services-types'
import {generateAndInjectImagesWorkflow} from './utils'
import {type UpscaleImageParams, fetchUpscaledImagesWorkflow} from './requests'
import {ERRORS} from '../constants'

export const upscaleImages = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, userRequestInfo, onSuccess, onError}: UpscaleImagesParams
): Promise<void> => {
    return generateAndInjectImagesWorkflow<UpscaleImageParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url) => ({
            imageUrl: url
        }),
        fetchUpscaledImagesWorkflow,
        {userRequestInfo, onSuccess, onError, caller: 'upscaleImages', errorType: ERRORS.IMAGES.UPSCALE_IMAGES}
    )
}
